import { lazy } from "react";
import { DefaultLayout } from "../../layout";
import { withSuspense } from "../../routes/helpers";

const Dashboard = lazy(() => import("./Dashboard"));

export function getDashboardRoutes() {
  return [
    { path: "/dashboard", layout: DefaultLayout, element: withSuspense(Dashboard) },
  ];
}
